var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin logo",
    clipPath: "url(#clip0_1086_307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.63281 15V4.87953H0.202508V15H3.63281ZM1.9181 3.49692C3.11431 3.49692 3.85889 2.71978 3.85889 1.74862C3.8366 0.755565 3.11436 0 1.9408 0C0.767434 0 0.00012207 0.75558 0.00012207 1.74862C0.00012207 2.71983 0.74452 3.49692 1.89571 3.49692H1.918H1.9181ZM5.53147 15H8.96177V9.34824C8.96177 9.04576 8.98406 8.7436 9.07465 8.52738C9.32263 7.92304 9.88705 7.29712 10.8346 7.29712C12.0759 7.29712 12.5725 8.2252 12.5725 9.5857V14.9999H16.0026V9.19695C16.0026 6.08834 14.3103 4.64193 12.0533 4.64193C10.2028 4.64193 9.39033 5.65626 8.93895 6.34712H8.96185V4.87932H5.53155C5.57657 5.82897 5.53155 14.9998 5.53155 14.9998L5.53147 15Z",
    fill: "#00058B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1086_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinlogo);
export default __webpack_public_path__ + "static/media/linkedin logo.43b1e4113af0a7e191c04dd201ce72f9.svg";
export { ForwardRef as ReactComponent };